const FormattedCreditCard = ({ cardType, lastFourDigits }) => `${cardType} ending in ${lastFourDigits}`;

export default FormattedCreditCard;
